const fancybox = require("@fancyapps/fancybox");
